<template>
  <div class="mt-6 w-full h-[592px] border border-secondary-300/40 rounded-xl">
    <div class="border-b border-secondary-300/40">
      <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
    </div>
  </div>
</template>
